// Month view selection and URL helpers (Refs: R1, R10)

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export interface YearMonth {
  year: number;
  month: number; // 1-12
}

export function utcYearMonth(now: Date = new Date()): YearMonth {
  return { year: now.getUTCFullYear(), month: now.getUTCMonth() + 1 }; // R10
}

export function isValidYearMonth(year: number, month: number): boolean {
  return Number.isInteger(year) && Number.isInteger(month) && year >= 2000 && year <= 2100 && month >= 1 && month <= 12;
}

export function parseViewMonth(search: string, now: Date = new Date()): YearMonth {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const year = Number.parseInt(params.get('year') || '', 10);
  const month = Number.parseInt(params.get('month') || '', 10);
  if (isValidYearMonth(year, month)) return { year, month };
  return utcYearMonth(now);
}

export function parseViewDay(search: string): string | undefined {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const day = (params.get('day') || '').trim();
  return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : undefined;
}

export function shiftMonth(view: YearMonth, delta: number): YearMonth {
  const d = new Date(Date.UTC(view.year, view.month - 1 + delta, 1));
  return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1 };
}

export function compareYearMonth(a: YearMonth, b: YearMonth): number {
  return a.year === b.year ? a.month - b.month : a.year - b.year;
}

export function canGoToPreviousMonth(view: YearMonth): boolean {
  return compareYearMonth(view, { year: 2000, month: 1 }) > 0;
}

export function canGoToNextMonth(view: YearMonth, now: Date = new Date()): boolean {
  return compareYearMonth(view, utcYearMonth(now)) < 0;
}

export function formatMonthTitle(view: YearMonth): string {
  const name = MONTH_NAMES[view.month - 1] || 'Unknown';
  return `${name} ${view.year}`;
}

export function monthQueryString(view: YearMonth): string {
  return `year=${view.year}&month=${view.month}`;
}

export function hrefForMonth(pathname: string, view: YearMonth, day?: string): string {
  const query = day && /^\d{4}-\d{2}-\d{2}$/.test(day)
    ? `${monthQueryString(view)}&day=${day}`
    : monthQueryString(view);
  return `${pathname}?${query}`;
}
